module.exports = __webpack_public_path__ + "img/earn-coin-white.25d85662.svg";